import { getUserConfig, setUserConfig, getUser, getToken } from '@/utils/User';
import { backendApi } from '@/utils/URL';

// use localStorage to keep value instead of cookie
export const getCookie = (name,json = false) => {
    //const cookies = new Cookies();
    //return cookies.get('token');
    var value = localStorage.getItem(name);

    let result = '';
    if(json){
        result = value;
    }
    else{
        result = JSON.parse(value);
    }

    return result;
}

export const setCookie = (name,value) => {
    //const cookies = new Cookies();
    //cookies.set("token",language,{path: '/'});
    var json = JSON.stringify(value);
    localStorage.setItem(name,json);
}

export const removeCookie = (name) => {
    localStorage.removeItem(name);
}

export const getLanguages = () => {

    const languages = [
        { 'name' : 'Español', 'value' : 'es'},
        { 'name' : 'Valencià', 'value' : 'ca'},      
        { 'name' : 'English', 'value' : 'en'}
    ];

    return languages;
}

// use localStorage to keep value
export const getLanguage = () => {    
    return getUserConfig("language");
}

export const setLanguage = (language) => {
    setUserConfig("language", language);
}

// to get the typical parameters to be used on different pages
export const getParameters = () => {
    
    const apiUrl = backendApi();
    const token = getToken();
    const user = getUser();
    const language = getLanguage();

    return { apiUrl, token, user, language}
}